import { Component, inject, OnInit } from '@angular/core';
import { PrimeNGButtonHeadingActionComponent } from '@ntap/primeng';
import { map, Observable, startWith, take } from 'rxjs';
import { isDatoteka } from '@app/shared/models/datoteka';
import { ContentDownloadService } from '../preuzmi-datoteku-dokument/preuzmi-datoteku-dokument.service';

@Component({
  selector: 'app-preuzmi-datoteke-dokumente',
  templateUrl: '../../shared/components/actions/common-action-template.html'
})
export class PreuzmiDatotekeDokumenteComponent
  extends PrimeNGButtonHeadingActionComponent
  implements OnInit
{
  enabled$: Observable<boolean>;

  contentDownloadService = inject(ContentDownloadService);

  ngOnInit(): void {
    this.initDisabledObservable();
  }

  override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider?.selectedItems$.pipe(
      startWith([]),
      map((items) => {
        const itemsArray = items as any[];
        if (itemsArray.length <= 0) {
          return true;
        }
        return items.some((item: any) =>
          isDatoteka(item) ? item['en~datoteka~rezidualni_podaci'] : false
        );
      })
    );
  }

  override executeAction(event: Event): void {
    this.listViewProvider?.selectedItems$
      .pipe(take(1))
      .subscribe((items: any[]) => {
        if (items.length > 0) {
          const itemsToDownload = items.map((item) => {
            return {
              objectType: 'en~datoteka',
              objectId: item['en~datoteka~id'],
              isFolder: item['en~datoteka~is_directory'] === true
            };
          });

          const download$ = this.contentDownloadService.downloadFiles(
            itemsToDownload,
            'default'
          );
          download$.subscribe({
            next: () => {
              this.notificationService.success('Preuzimanje je završeno.');
            },
            error: (error) => {
              const errorMessage = this.getErrorMessage(error);
              this.notificationService.error(
                'Greška kod prezimanja datoteke: ' + errorMessage
              );
            }
          });
        }
      });
  }

  private getErrorMessage(error: any): string {
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      return error.error.message;
    } else {
      // Server-side error
      return `Server returned code: ${error.status}, error message is: ${error.message}`;
    }
  }
}
